import { QrCode, LogOut } from "lucide-react";
import { MapPin } from "lucide-react";

const DashboardHeader = ({
  restaurant,
  handleLogout,
  tabs,
  activeTab,
  setActiveTab,
  onLogoClick,
}) => (
  <header className="bg-white/80  backdrop-blur-md shadow-lg border-b border-white/20 sticky top-0 z-40">
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center h-16">
        <div className="flex items-center space-x-3">
          <div className="relative">
            <button
              className="w-10 h-10 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg focus:outline-none"
              onClick={onLogoClick}
              title="Edit Restaurant Info"
            >
              {restaurant.logo ? (
                <img
                  src={restaurant.logo}
                  alt="Logo"
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                <QrCode className="w-6 h-6 text-white" />
              )}
            </button>
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse"></div>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h1 className="text-lg sm:text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent truncate">
                {restaurant.restaurantName || restaurant.name}
              </h1>
              {restaurant.address && (
                <span className="flex items-center text-sm text-gray-500 truncate">
                  <MapPin className="w-4 h-4 mr-1 text-gray-400" />
                  {restaurant.address}
                </span>
              )}
            </div>
            <p className="text-xs text-gray-400 hidden sm:block">
              {restaurant.phoneNumber}
              {restaurant.email && ` | ${restaurant.email}`}
              {(restaurant.openingTime || restaurant.closingTime) && (
                <span className="ml-2">
                  | Open: {restaurant.openingTime || "Not set"} -{" "}
                  {restaurant.closingTime || "Not set"}
                </span>
              )}
            </p>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="group flex items-center space-x-2 text-gray-600 hover:text-red-600 p-2 rounded-lg transition-all duration-200 hover:bg-red-50"
        >
          <LogOut className="w-4 h-4 transform group-hover:scale-110 transition-transform" />
          <span className="hidden sm:inline font-medium">Logout</span>
        </button>
      </div>
    </div>

    {/* Tab Navigation */}
    <div className="px-4 sm:px-6 lg:px-8 border-t border-gray-100 bg-white/60 backdrop-blur-sm">
      <nav className="flex overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`group flex items-center space-x-2 py-4 px-4 whitespace-nowrap border-b-3 font-medium text-sm min-w-0 transition-all duration-300 ${
              activeTab === tab.id
                ? `border-${tab.color}-500 text-${tab.color}-600 bg-${tab.color}-50/50`
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50/50"
            }`}
          >
            <tab.icon
              className={`w-4 h-4 flex-shrink-0 transition-all duration-200 ${
                activeTab === tab.id ? "scale-110" : "group-hover:scale-105"
              }`}
            />
            <span className="hidden sm:inline">{tab.name}</span>
          </button>
        ))}
      </nav>
    </div>
  </header>
);

export default DashboardHeader;
